import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import TestChat from './pages/TestChat'
import Compare from './pages/Compare'
import Files from './pages/Files'
import Memory from './pages/Memory'
import Projects from './pages/Projects'
import RoutingPreferences from './pages/Settings/RoutingPreferences'
import ModelCatalog from './pages/Models/ModelCatalog'
import NovitaDeployments from './pages/Models/NovitaDeployments'
import Usage from './pages/Analytics/Usage'
import Costs from './pages/Analytics/Costs'
import PromoCodes from './pages/Promo/PromoCodes'
import CreatorCodes from './pages/Creators/CreatorCodes'
import AuditLogs from './pages/Logs/AuditLogs'
import APILogs from './pages/Logs/APILogs'
import UserList from './pages/Users/UserList'
import UserDetail from './pages/Users/UserDetail'
import Layout from './components/Layout'

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/files" element={<Files />} />
                <Route path="/memory" element={<Memory />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/settings/routing" element={<RoutingPreferences />} />
                <Route path="/models" element={<ModelCatalog />} />
                <Route path="/novita" element={<NovitaDeployments />} />
                <Route path="/usage" element={<Usage />} />
                <Route path="/costs" element={<Costs />} />
                <Route path="/promo-codes" element={<PromoCodes />} />
                <Route path="/creators" element={<CreatorCodes />} />
                <Route path="/logs" element={<AuditLogs />} />
                <Route path="/users" element={<UserList />} />
                <Route path="/users/:id" element={<UserDetail />} />
                <Route path="/test-chat" element={<TestChat />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
